<template>
  <UApp>
    <AppHeader />
    <NuxtRouteAnnouncer />
    <NuxtPage />
  </UApp>
</template>
